import { AsyncPipe } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import {
	DYNAMIC_CONFIGS,
	FEAT_GATES,
	RS_REDIRECTION_TYPE,
	StatsigClientService
} from "@core-services/statsig/statsig.service";
import { combineLatest, Observable, map } from "rxjs";

interface IRealSecuritiesBannerInputs {
	enabled: boolean;
	type: Record<"value", RS_REDIRECTION_TYPE>;
	linkExists?: boolean;
}

@Component({
	selector: "real-securities-banner",
	templateUrl: "./real-securities-banner.component.html",
	styleUrls: ["./real-securities-banner.component.scss"],
	imports: [AsyncPipe],
	standalone: true
})
export class RealSecuritiesBannerComponent {
	private statsigService = inject(StatsigClientService);
	private realSecuritiesEnabled$ = this.statsigService.isFeatureActive(FEAT_GATES.REAL_SECURITIES_ENABLED);
	private realSecuritiesRedirectionType$ = this.statsigService.getDynamicConfig<Record<"value", RS_REDIRECTION_TYPE>>(
		DYNAMIC_CONFIGS.RS_REDIRECTION_TYPE
	);

	realSecuritiesBannerInputs$(): Observable<IRealSecuritiesBannerInputs> {
		return combineLatest({
			enabled: this.realSecuritiesEnabled$,
			type: this.realSecuritiesRedirectionType$
		}).pipe(
			map(({ enabled, type }) => ({
				enabled,
				type,
				linkExists: this.linkURL() !== "" && this.linkTitle() !== ""
			}))
		);
	}

	public REDIRECTION_TYPE = RS_REDIRECTION_TYPE;

	title = input<string>();
	subtitle = input<string>();
	linkTitle = input<string>();
	linkURL = input<string>();
}
